import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';

import type { Goal, GoalProps, GoalRecord } from './goalsTypes';

const goalsPayloadCreator = getPayloadCreator<Goal | GoalRecord>();
const syncGoalsPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<GoalProps>>();

export const getGoals = createAction('GET_GOALS', getPayloadCreator());
export const getGoalsSuccess = createAction('GET_GOALS_SUCCESS', syncGoalsPayloadCreator);
export const getGoalsFailure = createAction<unknown, 'GET_GOALS_FAILURE'>('GET_GOALS_FAILURE');

export const createGoal = createAction('CREATE_GOAL', goalsPayloadCreator);
export const createGoalSuccess = createAction('CREATE_GOAL_SUCCESS', goalsPayloadCreator);
export const createGoalFailure = createAction('CREATE_GOAL_FAILURE', errorPayloadCreator);

export const updateGoal = createAction('UPDATE_GOAL', goalsPayloadCreator);
export const updateGoalSuccess = createAction('UPDATE_GOAL_SUCCESS', goalsPayloadCreator);
export const updateGoalFailure = createAction('UPDATE_GOAL_FAILURE', errorPayloadCreator);

export const deleteGoal = createAction('DELETE_GOAL', goalsPayloadCreator);
export const deleteGoalSuccess = createAction('DELETE_GOAL_SUCCESS', goalsPayloadCreator);
export const deleteGoalFailure = createAction('DELETE_GOAL_FAILURE', errorPayloadCreator);

export const updateChangedGoals = createAction('UPDATE_CHANGED_GOALS', getPayloadCreator<GoalRecord[]>());
export const performCreateGoal = createAction(
  'PERFORM_CREATE_GOAL',
  getPayloadCreator<{
    goal: Goal | GoalRecord;
    contributions?: Array<null | { accountId?: string; amount?: number }>;
  }>(),
);

export const refreshGoalBalance = createAction('REFRESH_GOAL_BALANCE', getPayloadCreator<string>());

export const refreshGoalsBalances = createAction('REFRESH_GOALS_BALANCES');
